import * as PIXI from 'pixi.js'
import { startLoop, stopLoop } from 'macguffin/Utils/Loop'

const { Container } = PIXI

require('pixi-spine')

/**
 * Utility used to bind a container to a bone in a spine animation
 */
export default class BoneMerge extends Container {
  constructor() {
    super()
    const { destroy } = this

    startLoop(this.boneMergeLoop)

    this.destroy = (...args) => {
      stopLoop(this.boneMergeLoop)
      destroy.apply(this, ...args)
    }
  }
  init({
    spine,
    bone,
    rotationOffset = 0,
    offset = { x: 0, y: 0 },
    skewOffset = { x: 0, y: 0 },
    scaleOffset = { x: 1, y: 1 }
  }) {
    this.spine = spine
    this.boneName = bone
    this.rotationOffset = rotationOffset
    this.offset = offset
    this.skewOffset = skewOffset
    this.scaleOffset = scaleOffset
  }
  setSpine(spine) {
    this.spine = spine
  }
  setOffset(offset) {
    this.offset = offset
  }
  setRotationOffset(rotationOffset) {
    this.rotationOffset = rotationOffset
  }
  setSkewOffset(skewOffset = { x: 0, y: 0 }) {
    this.skewOffset = skewOffset
  }
  setScaleOffset(scaleOffset = { x: 1, y: 1 }) {
    this.scaleOffset = scaleOffset
  }
  boneMergeLoop = () => {
    const {
      spine,
      boneName,
      offset,
      rotationOffset,
      scaleOffset,
      skewOffset
    } = this

    if (spine && spine.skeleton && boneName) {
      const bone = spine.skeleton.bones.find(({ data: { name } }) => name === boneName)
      if (!bone) return
      this.transform.setFromMatrix(bone.matrix)
      const {
        rotation,
        position,
        scale,
        skew
      } = this.transform
      // Gotta flip the Y scale for some reason, thanks pixi-spine
      this.transform.scale.set(scale.x * scaleOffset.x, -scale.y * scaleOffset.y)
      this.transform.skew.set(skew.x + skewOffset.x, skew.y + skewOffset.y)
      this.transform.position.set(position.x + offset.x, position.y + offset.y)
      this.transform.rotation = rotation + ((rotationOffset / 180) * Math.PI)
      const slot = spine.skeleton.slots.find(({ bone: { data: { name } } }) => name === boneName)
      // If there's also a slot assigned to this bone, copy the slot's properties
      // (color data and the like)
      if (!slot) return
      const { color, tint } = slot
      this.alpha = color.a
      this.tint = tint
    }
  }
}
